module.exports = __webpack_public_path__ + "img/magdar-logo.4671ccee.png";